const cart = require('loyalty/cart/cart');
const base = require('site/product/base');
const { showMessage } = require('../utils/messageUtils');

function appendToUrl(url, params) {
    let newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map((key) => `${key}=${encodeURIComponent(params[key])}`).join('&');

    return newUrl;
}

function addToCart(pid, autoshipFrequency) {
    const addToCartUrl = $('.add-to-cart-url').val();

    var form = {
        pid,
        quantity: 1,
    };

    if (autoshipFrequency) {
        form.autoshipFrequency = autoshipFrequency;
    }

    $.ajax({
        url: addToCartUrl,
        method: 'POST',
        data: form,
        success() {
            window.location.reload();
        },
        error() {
            $.spinner().stop();
        },
    });
}

/**
 * Convenience function for showing cart errormessages
 * @param {Object} options - Configuration options
 * @returns {HTMLElement|null} - The created alert element or null if failed
 */
function showCartErrorMessage(options = {}) {
    const cartOptions = {
        message: 'Something went wrong. Please try again. If it continues, contact customer service.',
        autoDismiss: 5,
        containerSelector: '.js-cart-messages',
        customClass: 'text-center',
        type: 'danger',
        ...options,
    };

    return showMessage(cartOptions);
}

/**
 * Initialize Bootstrap popovers on cart page
 * @param {string} selector - Optional selector for popover elements (default: '[data-toggle="popover"]')
 * @param {Object} options - Optional Bootstrap popover options
 */
function initializePopovers(selector = '[data-toggle="popover"]', options = {}) {
    const defaultOptions = {
        trigger: 'hover focus',
    };

    const popoverOptions = Object.assign(defaultOptions, options);

    $(selector).popover(popoverOptions);
}

/**
 * Handle cart update events
 */
function handleCartUpdate() {
    $('body').on('cart:update', () => {
        window.location.reload();

        // if (!data.isSameDayProduct) {
        //     const $perishableAlert = $('.cart-totals .same-day-perishable');

        //     if ($perishableAlert) {
        //         $perishableAlert.parents('.cart-totals').remove();
        //     }
        // }
    });

    $('body').off('change', '.quantity-form > .quantity').on('change', '.quantity-form > .quantity', function (e) {
        e.stopImmediatePropagation();

        const quantity = $(this).val();
        const productID = $(this).data('pid');
        const uuid = $(this).data('uuid');
        const isPickupSelected = $(this).closest('.product-card').find('input[name^="deliveryOption-"]:checked').val() === 'pickup';
        let url = $(this).data('action');

        const urlParams = {
            pid: productID,
            quantity,
            uuid,
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url,
            type: 'get',
            context: this,
            dataType: 'json',
            success(data) {
                if (!isPickupSelected && data.localDelivery && data.localDelivery.movedToGround) {
                    $('#delivery-product-uuid').val(uuid);
                    $('#delivery-page').val('cart');

                    // Populate modal with data
                    const groundDate = data.localDelivery.groundAvailableDate;
                    const groundDateInDays = data.localDelivery.groundAvailableInDays || '7';

                    const { bestStoreQuantity } = data.localDelivery;

                    $('#deliveryUpdateModal .delivery-date').text(groundDate);
                    $('#deliveryUpdateModal .delivery-date-days').text(groundDateInDays);
                    $('#deliveryUpdateModal .available-quantity').text(bestStoreQuantity);
                    $('#deliveryUpdateModal .js-available-quantity').val(bestStoreQuantity);
                    $('#deliveryUpdateModal .js-reduce-quantity-estimate').text(data.localDelivery.nextDay ? 'tomorrow' : 'today');

                    $('#deliveryUpdateModal #deliveryUpdateReduceQuantity').prop('checked', false);
                    $('#deliveryUpdateModal #deliveryUpdateKeepAll').prop('checked', true);

                    $('#deliveryUpdateModal').modal('show');
                } else {
                    $(`.quantity[data-uuid="${uuid}"]`).val(quantity);
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    $(this).data('pre-select-qty', quantity);

                    $('body').trigger('cart:update');
                }
            },
            error(err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    $('body').trigger('cart:update');
                }
            },
        });
    });

    $('body').on('click', '#deliveryUpdateAccept', () => {
        const selectedChoice = $('input[name="deliveryUpdateChoice"]:checked').val();

        const productUUID = $('#delivery-product-uuid').val();
        const deliveryPage = $('#delivery-page').val();

        if (selectedChoice === 'reduceQuantity') {
            let $quantitySelector;
            const availableQuantity = $('#deliveryUpdateModal .js-available-quantity').val();

            if (deliveryPage === 'cart') {
                $quantitySelector = $(`[data-product-uuid="${productUUID}"]`).find('.quantity-form .quantity');
            } else {
                $quantitySelector = $('.quantity-select');
            }

            if ($quantitySelector && $quantitySelector.length && availableQuantity) {
                $quantitySelector.val(availableQuantity);
                $.spinner().stop();
                $quantitySelector.trigger('change');
            }
        }

        $('#deliveryUpdateModal').modal('hide');
    });

    $('body').on('hidden.bs.modal', '#deliveryUpdateModal', () => {
        const deliveryPage = $('#delivery-page').val();
        if (deliveryPage === 'cart') {
            $('body').trigger('cart:update');
        }
    });
}

/**
 * Handle quantity input validation
 */
function handleQuantityValidation() {
    $('.product-info .quantity').on('keydown', (e) => {
        const invalidChars = ['-', '+', 'e', 'E', '.'];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
        return true;
    });
}

/**
 * Handle Save for later button functionality
 */
function handleSaveForLater() {
    $('body').on('click', '.js-save-for-later', function (e) {
        e.preventDefault();

        const productID = $(this).data('pid');
        let url = $(this).data('action');
        const uuid = $(this).data('uuid');

        const urlParams = {
            pid: productID,
            uuid,
            saveForLater: true,
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();

        $.ajax({
            url,
            type: 'get',
            dataType: 'json',
            success() {
                window.location.reload();
            },
            error(err) {
                showCartErrorMessage();

                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    });
}

/**
 * Update delivery option for a product via AJAX
 */
function updateDeliveryOption(uuid, shipmentUUID, deliveryOption, autoshipFrequency) {
    $.spinner().start();

    const defaultError = 'Something went wrong while updating your delivery option. Please try again. If it continues, contact customer service.';
    const url = $('.js-delivery-urls').data('update-delivery-url');

    const requestData = {
        uuid,
        shipmentUUID,
        deliveryOption,
        autoshipFrequency,
    };

    $.ajax({
        url,
        type: 'POST',
        data: requestData,
        dataType: 'json',
        success(data) {
            if (data.success) {
                if (deliveryOption === 'autoship') {
                    // Get the selected frequency text from the dropdown
                    const selectedOption = $('#autoship-frequency-select option:selected');
                    const intervalText = selectedOption.data('interval-text') || selectedOption.text();

                    // Update the feedback elements
                    $('.js-autoship-interval-selected').text(intervalText);
                    $('.autoship-interval-feedback').removeClass('d-none');
                    $('.autoship-notice-content').removeClass('d-none');
                    $('#autoshipFrequencyForm').addClass('d-none');
                    $('.js-autoship-frequency-footer').addClass('d-none');

                    $.spinner().stop();

                    // Set the response data to be used on modal dismiss
                    $('#autoshipFrequencyModal').data('cart-update-data', data);
                } else {
                    $('body').trigger('cart:update', data);
                }
            } else {
                showCartErrorMessage({
                    message: data.errorMessage || defaultError,
                });
                $.spinner().stop();
            }
        },
        error(xhr, status, error) {
            showCartErrorMessage({
                message: error || defaultError,
            });
            $.spinner().stop();
        },
    });
}

function showAutoshipFrequencyModal(productUUID, shipmentUUID, previousDeliveryOption, isAddToCart) {
    const $modal = $('#autoshipFrequencyModal');

    $('#autoship-product-uuid').val(productUUID);
    $('#autoship-shipment-uuid').val(shipmentUUID || '');
    $('#autoship-add-to-cart').val(isAddToCart || '');

    // Store the previous delivery option to restore if modal is cancelled
    $modal.data('previous-delivery-option', previousDeliveryOption);

    // Reset the form and modal state
    $modal.find('#autoship-frequency-select').val('');
    $modal.find('#autoshipFrequencySubmit').prop('disabled', true);
    $modal.find('#autoshipFrequencyForm').removeClass('d-none');
    $modal.find('.autoship-interval-feedback').addClass('d-none');
    $modal.find('.autoship-notice-content').addClass('d-none');
    $modal.find('.js-autoship-frequency-footer').removeClass('d-none');
    $modal.find('.js-autoship-interval-selected').text('');

    // Clear any previous data flags
    $modal.removeData('cart-update-data');

    // Show the modal
    $modal.modal('show');
}

function handleAutoshipFrequencyModal() {
    $('body').on('change', '#autoship-frequency-select', function () {
        const selectedFrequency = $(this).val();
        $('#autoshipFrequencySubmit').prop('disabled', !selectedFrequency);
    });

    $('body').on('click', '#autoshipFrequencySubmit', () => {
        const productUUID = $('#autoship-product-uuid').val();
        const autoshipFrequency = $('#autoship-frequency-select').val();

        if (!autoshipFrequency) {
            return;
        }

        if ($('#autoship-add-to-cart').val() === 'true') {
            $('#autoshipFrequencyModal').spinner().start();
            addToCart(productUUID, autoshipFrequency);
        } else {
            updateDeliveryOption(productUUID, null, 'autoship', autoshipFrequency);
        }
        // updateDeliveryOption(productUUID, null, 'autoship', autoshipFrequency);
    });

    // Handle modal close events (X button, ESC key, backdrop click)
    $('body').on('hidden.bs.modal', '#autoshipFrequencyModal', (e) => {
        if ($('#autoship-add-to-cart').val() === 'true') {
            return;
        }

        const $modal = $(e.target);
        const cartUpdateData = $modal.data('cart-update-data');
        const previousOption = $modal.data('previous-delivery-option');

        if (cartUpdateData) {
            // Successful frequency selection - trigger cart update
            $('body').trigger('cart:update', cartUpdateData);
            $modal.removeData('cart-update-data');
        } else if (previousOption) {
            // Modal closed without frequency selection - restore previous delivery option
            const $deliveryOption = $(`#${previousOption}`);
            const productUUID = $modal.find('#autoship-product-uuid').val();
            $deliveryOption.prop('checked', true);

            $(`[data-product-uuid="${productUUID}"]`).data('previous-delivery-option', previousOption);
        }

        // Clean up stored data
        $modal.removeData('previous-delivery-option');
    });
}

/**
 * Handle delivery option changes for cart products
 */
function handleDeliveryOptionChange() {
    $('.shipping-card-products .product-card').each(function () {
        const $productCard = $(this);
        const $previouslySelected = $productCard.find('input[name^="deliveryOption-"]:checked');
        const previousId = $previouslySelected.length ? $previouslySelected.attr('id') : '';
        $productCard.data('previous-delivery-option', previousId);
    });

    $('body').on('change', 'input[name^="deliveryOption-"]', function (e) {
        const $input = $(this);
        const selectedValue = $input.val();
        const $productCard = $input.closest('.product-card');
        const productUUID = $productCard.data('product-uuid');
        const shipmentUUID = $productCard.data('shipment-uuid');
        const previousDeliveryOption = $productCard.data('previous-delivery-option');

        // If autoship is selected, show the frequency modal instead of directly updating
        if (selectedValue === 'autoship') {
            showAutoshipFrequencyModal(productUUID, shipmentUUID, previousDeliveryOption);
        } else {
            updateDeliveryOption(productUUID, shipmentUUID, selectedValue || 'local');
        }

        // Store current selection as previous for next change
        $productCard.data('previous-delivery-option', e.target.id);
    });

    $('body').on('change', 'input[name="deliveryShippingMethod"]', function () {
        const shippingMethod = $(this).val() || 'ground';

        $.spinner().start();

        const url = $('.js-delivery-urls').data('update-shipping-url');

        const requestData = {
            shippingMethod,
        };

        $.ajax({
            url,
            type: 'POST',
            data: requestData,
            dataType: 'json',
            success(data) {
                if (data.success) {
                    $('body').trigger('cart:update', data);
                } else {
                    showCartErrorMessage();
                    $.spinner().stop();
                }
            },
            error() {
                showCartErrorMessage();
                $.spinner().stop();
            },
        });
    });
}

/**
 * Handle Add to Cart button clicks in favorites section
 */
function handleFavoritesAddToCart() {
    $('body').on('click', '.btn-add-to-cart', function (e) {
        e.preventDefault();

        const pid = $(this).data('pid');

        if (pid) {
            $.spinner().start();

            addToCart(pid, null);
        }
    });
}

/**
 * Handle Add to Cart button clicks in favorites section
 */
function handleFavoritesAddToAutoship() {
    $('body').on('click', '.btn-start-autoship', function (e) {
        e.preventDefault();

        const pid = $(this).data('pid');

        showAutoshipFrequencyModal(pid, null, null, 'true');
    });
}

/**
 * Handle Remove button clicks in favorites section
 */
function handleFavoritesRemove() {
    $('body').on('click', '.btn-remove-favorite-item', function (e) {
        e.preventDefault();

        const pid = $(this).data('pid');
        const url = $(this).data('action');
        // const $productCard = $(this).closest('.product-card');

        $.spinner().start();

        $.ajax({
            url,
            method: 'POST',
            data: { pid },
            dataType: 'json',
            success() {
                window.location.reload();
            },
            error() {
                showCartErrorMessage({
                    message: 'Something went wrong while removing the product. Please try again. If it continues, contact customer service.',
                });
                $.spinner().stop();
            },
        });
    });
}

/**
 * Initialize Bootstrap tabs for favorites section
 */
function initializeFavoritesTabs() {
    // Initialize Bootstrap 4.6.1 tabs
    if (typeof $ !== 'undefined' && $.fn.tab) {
        // Bootstrap 4 tabs with data-toggle="tab"
        $('.favorites-tabs a[data-toggle="tab"]').on('click', function (e) {
            e.preventDefault();
            $(this).tab('show');
        });
    }
}

function initializeNoAddressHint() {
    $('body').on('click', '.no-address-hint > button', function () {
        $(this).closest('.no-address-hint').remove();
    });
}

/**
 * Initialize all cart functionality
 */
function initializeCart() {
    cart();
    base.commonAttributes();

    handleCartUpdate();
    handleQuantityValidation();
    handleSaveForLater();
    handleDeliveryOptionChange();
    handleAutoshipFrequencyModal();
    handleFavoritesAddToCart();
    handleFavoritesAddToAutoship();
    handleFavoritesRemove();
    initializeFavoritesTabs();
    initializePopovers();
    initializeNoAddressHint();
}

// Export the main initialization function for backward compatibility
module.exports = initializeCart;

// Attach individual methods to the main function for modular access
module.exports.init = initializeCart;
module.exports.initializePopovers = initializePopovers;
module.exports.handleCartUpdate = handleCartUpdate;
module.exports.handleQuantityValidation = handleQuantityValidation;
module.exports.handleSaveForLater = handleSaveForLater;
module.exports.handleDeliveryOptionChange = handleDeliveryOptionChange;
module.exports.updateDeliveryOption = updateDeliveryOption;
module.exports.handleFavoritesAddToCart = handleFavoritesAddToCart;
module.exports.handleFavoritesRemove = handleFavoritesRemove;
module.exports.initializeFavoritesTabs = initializeFavoritesTabs;
